module.exports = __webpack_public_path__ + "img/0070.58d82ecc.png";